export const STORAGE_KEY = 'bhp.optimiser.finishedRuns';

// All localStorage access for the finished-run list is isolated here so the
// reducer stays pure/testable and a disabled or failing localStorage degrades
// gracefully to in-memory (the feature still works for the session).
export const read = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  }
  catch (e) {
    return [];
  }
};

export const write = (list) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }
  catch (e) {
    // localStorage unavailable/full — fall back to in-memory only.
  }
};
